import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Button, Row, Col, Form, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import OuvidoriaService from '../../../services/ouvidoria';
import { Chart as ChartJS, Tooltip, Legend, CategoryScale, BarElement, LinearScale } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import Exportar from '../../../components/shared/export';

ChartJS.register(BarElement, Tooltip, Legend, CategoryScale, LinearScale);



const ListarOuvidoria = () => {
    const [ano, setAno] = useState();
    const [tipo, setTipo] = useState();
    const [situacoes, setSituacoes] = useState([]);
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [
                    'red',
                    'green',
                    'blue',
                    'orange',
                    'yellow',
                    'purple',
                    'gray',
                    'maroon',
                    'fuchsia',
                    'navy'
                ],
            },
        ],
    });


    const contador = async (filtros) => {
        const situacaoCores = {
            'Resolvido': 'green',
            'Encerrado': 'green',
            'Recebido pela Prefeitura': 'blue',
            'Respondido': 'blue',
            'Pendente': 'yellow',
            'Encaminhada à Secretaria Responsável': 'orange',
            'Secretaria Responsável está atuando': 'orange',
            'Indeferido, justificado via mensagem': 'red',
            '1º Recurso': 'purple',
            '2º Recurso': 'purple',
            'Último Recurso': 'purple',
            'Encaminhado à Autoridade Superior': 'purple',
        };

        try {
            const response = await OuvidoriaService.contarSituacao(filtros);
            const dados = response.data;

            // Determina o tipo de agrupamento pelo primeiro item retornado
            const tipo = dados.length > 0
                ? Object.keys(dados[0])[0]
                : 'situacao';

            const labels = dados.map(item => item[tipo]);
            const data = dados.map(item => item.count);

            // Se for situação → usa o mapeamento fixo; caso contrário → gera cores automáticas
            let backgroundColor = [];

            if (tipo === 'situacao') {
                backgroundColor = labels.map(situacao => situacaoCores[situacao] || 'gray');
            } else {
                // Gera cores distintas automaticamente usando HSL
                backgroundColor = labels.map((_, i) => `hsl(${(i * 360) / labels.length}, 70%, 55%)`);
            }

            // Define o label do gráfico conforme o tipo
            const labelNome = tipo === 'situacao'
                ? 'Requisições por Situação'
                : tipo === 'sexo'
                    ? 'Requisições por Gênero'
                    : 'Requisições por Cidade';

            setSituacoes(dados);
            setChartData({
                labels,
                datasets: [
                    {
                        label: labelNome,
                        data,
                        backgroundColor,
                    },
                ],
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    useEffect(() => {
        contador(ano)
    }, []);

    const busca = async (query) => {
        if (query === "") {
            await contador();
        } else {
            var response = await contador(query);
            if (response.data.length >= 1) {
                setAno("")
            } else {
                setAno("")
            }
        }
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        if (tipo) prepQuery = prepQuery + `&tipo=${tipo}`;
        return prepQuery;
    }

    return (
        <Fragment>
            <Row xs={1} lg={3}>
                <Col xs={12} lg={4}>
                    <Form.Group className="mb-3" controlId="Ano">
                        <Form.Label>Ano de Exercício</Form.Label>
                            <Form.Control
                                required
                                type="number"
                                name="ano"
                                value={ano}
                                onChange={e => setAno(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col xs={12} lg={5}>
                    <Form.Group className="mb-3" controlId="tipo">
                         <Form.Label style={{ fontSize: "12px" }}>Tipo de Relatório (Situação, Gênero, Cidade)</Form.Label>
                            <Form.Select
                                required
                                aria-label="tipo"
                                name="tipo"
                                onChange={e => setTipo(e.target.value)}
                            >
                                <option value="situacao">Situação</option>
                                <option value="sexo">Gênero</option>
                                <option value="cidade">Cidade</option>
                            </Form.Select>
                    </Form.Group>
                </Col>
                <Col xs={12} lg={2}>
                    <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                </Col>
            </Row>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                    <Accordion.Body>
                        <Row xs={1}>
                            <Col xs={12}>
                                <Exportar data={situacoes} nome={"Situacoes"} />
                            </Col>
                        </Row>
                        <br />
                        <Row xs={1}>
                            <Col xs={12}>
                                <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#445fc07b-ec10-48c1-8cdf-94a0ad21457c" target='_blank'>
                                    <Button>API e sua documentação</Button>
                                </a>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <div style={{ width: '75%', height: '750px', display: 'block', margin: '1rem auto' }}>
                <Bar data={chartData} />
            </div>
            <br />
            <br />
            <br />
            <Link to={'/ouvidoria'}>
                <Button variant="danger" type="button">
                    Voltar
                </Button>
            </Link>
        </Fragment>
    );
};

export default ListarOuvidoria;